export default __webpack_public_path__ + "static/media/schoolDiscountImage.d08737c4.jpg";